<app-review-section
  [title]="'overview.process-details.order-process-title' | translate"
  *ngIf="orderProcess"
  [showAcceptRejectButtons]="false"
  [showMessages]="false">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 buttons-container">
    <button
      *ngIf="showApproveApplicationBtn"
      (click)="updateOrderProcess(SkExecutorAction.application_accepted)"
      [disabled]="!(areAllSectionsApproved$ | async)"
      class="view-btn-width"
      id="approve-application-btn"
      label="{{ 'overview.process-details.approve-offer-btn' | translate }}"
      pButton
      type="button"></button>

    <button
      *ngIf="showRejectApplicationBtn"
      (click)="updateOrderProcess(SkExecutorAction.application_rejected)"
      [disabled]="!(areAnySectionsRejected$ | async)"
      class="view-btn-width"
      id="deny-application-btn"
      label="{{ 'overview.process-details.reject-offer-btn' | translate }}"
      pButton
      type="button"></button>

    <button
      *ngIf="showRequestUpdateApplicationBtn"
      (click)="updateOrderProcess(SkExecutorAction.request_update_application)"
      [disabled]="!(areAnySectionsRejected$ | async)"
      class="view-btn-width"
      id="deny-application-btn"
      label="{{ 'overview.process-details.application-update-request-button' | translate }}"
      pButton
      type="button"></button>

    <button
      *ngIf="showUpdateApplicationBtn"
      (click)="updateApplication.emit({ executorAction: SkExecutorAction.update_application })"
      class="view-btn-width"
      id="deny-application-btn"
      label="{{ 'overview.process-details.update-application-button' | translate }}"
      pButton
      type="button"></button>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mt-20 status-container">
    {{ 'overview.process-details.current-status' | translate }} :
    {{ 'lookup.' + AllDropdownKeys.OrderProcess + '.options.' + orderProcess[AllDropdownKeys.OrderProcess] + '.name' | translate }}
  </div>
</app-review-section>
